module.exports = __webpack_public_path__ + "static/media/ZGO__i3.39ce6915.png";